export default "__VITE_PUBLIC_ASSET__9fe5ccb6__"